import type React from 'react';
import type { EntityDrawer as EntityDrawerType } from '../../state/EntityExplorer/EntityExplorerContext';
import { useEntityExplorer } from '../../state/EntityExplorer/useEntityExplorer';
import Panel from '../../styled-components/components/Panel';
import { CustomerDrawerContent } from './CustomerDrawerContent';
import { VehicleDrawerContent } from './VehicleDrawerContent';

interface EntityDrawerProps {
  drawer: EntityDrawerType;
}

/**
 * Individual entity drawer component
 * Uses Panel component for consistent UI
 */
export const EntityDrawer: React.FC<EntityDrawerProps> = ({ drawer }) => {
  const { closeDrawer } = useEntityExplorer();

  const handleClose = () => {
    closeDrawer(drawer.id);
  };

  return (
    <Panel id={`entity-drawer-${drawer.id}`} title={drawer.title} onClose={handleClose}>
      {drawer.type === 'customer' && (
        <CustomerDrawerContent entityId={drawer.entityId} onClose={handleClose} />
      )}
      {drawer.type === 'seller' && (
        <CustomerDrawerContent entityId={drawer.entityId} onClose={handleClose} />
      )}
      {drawer.type === 'business' && (
        <CustomerDrawerContent entityId={drawer.entityId} onClose={handleClose} />
      )}
      {drawer.type === 'vehicle' && (
        <VehicleDrawerContent entityId={drawer.entityId} onClose={handleClose} />
      )}
    </Panel>
  );
};
